import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import MyContainer from '@/components/MyContainer';
import { LinkButton } from '@/components/ui/buttons/link-button';
import { navigate } from 'wouter/use-browser-location';
import { routes } from '@/routes/route-constants';
import UserAsyncTable from '@/components/users/user-async-data-table';

export default function UsersPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return <div>You must be logged in</div>;

  return (
    <MyContainer
      title="Users"
      subtitle="Manage users who can access to the system"
      enableBack={false}
      actions={
        <>
          <LinkButton label="User" onClick={() => navigate(routes.user.new())} />
        </>
      }
    >
      <UserAsyncTable />
    </MyContainer>
  );
}
